import { useAccountTypeNavigation } from "../../../hooks/useAccountTypeNavigation";
import { BANKS_BREADCRUMB, BANKS_PATH, BANKS_STRUCTURE_CRUMBS } from "./banks.constants";

export function useBanksNavigation() {
  return useAccountTypeNavigation({
    path: BANKS_PATH,
    listBreadcrumb: BANKS_BREADCRUMB.list,
    structureCrumbs: BANKS_STRUCTURE_CRUMBS,
    editLastBreadPath: BANKS_PATH,
    enableDocumentRowSelect: true,
  });
}
